import React from 'react';

const Pagination = ({ totalPages, currentPage, onPageChange, totalItems }) => {
	// Function to handle page changes
	const handlePageChange = (page) => {
		if (page > 0 && page <= totalPages) {
			onPageChange(page);
		}
	};

	// Function to determine which page numbers to display
	const getPageNumbers = () => {
		if (totalPages <= 3) {
			return Array.from({ length: totalPages }, (_, index) => index + 1);
		}

		const pages = [];

		// Always show the first page
		pages.push(1);

		// Add ellipsis if there are more than 3 pages between currentPage and 1
		if (currentPage > 3) {
			pages.push('...');
		}

		// Add a range of pages around the current page
		const start = Math.max(currentPage - 1, 2); // Start 1 before the current page
		const end = Math.min(currentPage + 1, totalPages - 1); // End 1 after the current page
		for (let i = start; i <= end; i++) {
			pages.push(i);
		}

		// Add ellipsis if there are more than 2 pages between currentPage and totalPages
		if (currentPage < totalPages - 2) {
			pages.push('...');
		}

		// Always show the last page
		if (totalPages > 1) {
			pages.push(totalPages);
		}

		return pages;
	};

	const pageNumbers = getPageNumbers();

	// Render pagination only if there are more than one page
	// if (totalPages <= 1) {
	// 	return null;
	// }

	return (
		<div className='flex flex-col items-center mt-4 text-sm'>
			<div className='flex items-center mb-2 text-gray-600'>
				<span>
					Page {currentPage} of {totalPages} | Total Items: {totalItems}
				</span>
			</div>
			<div className='flex items-center space-x-1'>
				{/* First page button */}
				<button
					onClick={() => handlePageChange(1)}
					disabled={currentPage === 1}
					className='px-2 py-1 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50 text-xs transition-colors duration-200'
				>
					&#171;
				</button>

				{/* Previous page button */}
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
					className='px-2 py-1 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50 text-xs transition-colors duration-200'
				>
					&lt;
				</button>

				{pageNumbers.map((page, index) =>
					page === '...' ? (
						<span key={index} className='px-2 py-1 text-gray-600 text-xs'>
							&hellip;
						</span>
					) : (
						<button
							key={index}
							onClick={() => handlePageChange(page)}
							className={`px-2 py-1 rounded text-xs transition-colors duration-200 ${
								currentPage === page
									? 'bg-blue-500 text-white'
									: 'bg-gray-200 text-gray-800 hover:bg-gray-300'
							}`}
						>
							{page}
						</button>
					)
				)}

				{/* Next page button */}
				<button
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
					className='px-2 py-1 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50 text-xs transition-colors duration-200'
				>
					&gt;
				</button>

				{/* Last page button */}
				<button
					onClick={() => handlePageChange(totalPages)}
					disabled={currentPage === totalPages}
					className='px-2 py-1 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50 text-xs transition-colors duration-200'
				>
					&#187;
				</button>
			</div>
		</div>
	);
};

export default Pagination;
